import { Component, Input } from '@angular/core';
import { forEach } from 'lodash';
import { QResult } from '../models';
import { Item, WalletInfo } from '../models/payment';
import { CoreService, HttpService } from '../services';
import { PaymentStripeService } from '../services/paymentStripe.service';
import { ToastService } from '../toast';

@Component({
  selector: 'q-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent {

  @Input('items') set SetListChaptersEL(value: Array<Item>) {
    if (value) this.Items = value;
    this.Items = value.filter(item => item.Quantity > 0);
  }

  @Input('mode') set SetMode(value: string) {
    if (value) this.mode = value;
  }

  @Input('refreshWallet') set SetRefreshWallet(value: boolean) {
    if (value) this.refreshWallet();
  }

  @Input('price') set SetPrice(value: number) {
    if (value) this.price = value;
  }

  public isLoading: boolean = false;
  private Items: Array<Item>;
  private mode: string;
  public price: number = 0;
  public showWallet: boolean = true;

  constructor(
    public http: HttpService,
    public indParam: CoreService,
    public paymentStripeService: PaymentStripeService,
    public toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.refreshWallet();

  }

  displayStripe() {
    this.paymentStripeService.mode = this.mode;
    this.paymentStripeService.model.Items = this.Items;
    this.paymentStripeService.showStripe = true;
  }

  refreshWallet() {
    this.isLoading = true;
    this.http.getHttp<QResult<WalletInfo>>(`${this.indParam.AppParams.apiUrl}api/getwallet`).subscribe(
      (data: QResult<WalletInfo>) => {
        if (!data.HasAlert) {
          this.paymentStripeService.wallet = data.Value.WalletAmount;
          this.isLoading = false;
          this.paymentStripeService.endProcess = false;
        } else {
          this.showWallet = false;
          this.toastService.showWarningToast(data.Alert);
        }
      });
  }
}
